module.exports = __webpack_public_path__ + "components/country-flag/static/tn-e7a54d013700858a7a3fbaa3020b0a68.svg";